import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../shared/app.config';
import { IUiAuthorizations } from './state';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationsService {

  constructor(private readonly http: HttpClient, private readonly config: AppConfig) {
  }

  getAuthorizations(authMode: 'relaxed' | 'strict', context: string) {
    const url = this.config.uiAuthorizationsUrl + '?type=' + (authMode === 'relaxed' ? 'R' : 'S') + '&' + 'context=' + context;
    return this.http.get<IUiAuthorizations>(url);
  }
}
